export default __webpack_public_path__ + "static/media/pic3.6c09b387.jpg";